<template>
  <h3 class="h3">Mit welchen Führerscheinklassen möchtest du deinen Führerschein erweitern?</h3>

  <h4 class="h4">Motorrad</h4>
  <div class="default-flex">
    <ClassButton :fclass="FührerscheinKlassen.A" additional-text="unbegrenzt"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.A2" additional-text="bis 35kW (48PS)"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.A1" additional-text="bis 125 cm³ und 11kW (15PS)"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.CODE111" additional-text="bis 125 cm³ und 11kW (15PS)<br/>bei Besitz eines B Führerscheins"></ClassButton>
  </div>

  <h4 class="h4">Auto</h4>
  <div class="default-flex">
    <ClassButton :fclass="FührerscheinKlassen.B" additional-text="Auto ab 18"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.BL17" additional-text="Auto ab 17"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.BDUAL" additional-text="Auto ab 18<br/>1000km Fahrt mit Eltern oder Bekannten"></ClassButton>
  </div>

  <h4 class="h4">LKW</h4>
  <div class="default-flex">
    <ClassButton :fclass="FührerscheinKlassen.C" additional-text="LKW"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.CE" additional-text="LKW mit Anhänger"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.C1" additional-text="LKW unter 21 Jahren"></ClassButton>
  </div>

  <h4 class="h4">Anhänger</h4>
  <div class="default-flex">
    <ClassButton :fclass="FührerscheinKlassen.EZUB" additional-text="Anhänger ab 750kg"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.EZUBWENNF" additional-text="Anhänger ab 750kg<br/>nach mindestens 3 Jahren Besitz von Führerschein F"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.CODE96" additional-text="Anhänger ab 750kg<br/>Höchszulässige Gesamtmasse kleiner als 4250kg"></ClassButton>
    <ClassButton :fclass="FührerscheinKlassen.EZUC" additional-text="LKW Anhänger"></ClassButton>
  </div>

  <h4 class="h4">Traktor</h4>
  <div class="default-flex">
    <ClassButton :fclass="FührerscheinKlassen.F"></ClassButton>
  </div>

  <h4 class="h4">Moped</h4>
  <div class="default-flex">
    <ClassButton :fclass="FührerscheinKlassen.AM" additional-text="bis 50cm³"></ClassButton>
  </div>

  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, Navigation, FührerscheinKlassen } from '../models/enums'
import ClassButton from '../components/ClassButton.vue'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';

const store = useStore();
const nextDisabled = computed(() => store.state.newDriverLicenceClasses.length <= 0);

const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  store.commit("updateStep", DetailStep.TERMIN_STANDORT);
  scrollToTop();
}
</script>

<style scoped lang="scss">
h4 {
  @apply mt-3 mb-2;
}
.default-flex {
  @apply flex gap-2 flex-wrap;
}
</style>
